import { Fab, styled } from '@mui/material'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

export const CustomFab = styled(Fab)(({ theme }) => ({
  right: 20,
  bottom: 20,
  position: 'fixed',
  color: '#fff',
  backgroundColor: theme.palette.primary.dark,
  zIndex: 1300,
  '&:hover': {
    backgroundColor: colorTokens.special.fabHover,
    color: '#fff',
  },
}))
